import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { LanguageSelector } from "../language-selector";
import { Text } from "../../contexts/language";
import { useMenu } from "../../hooks/use-menu";

import styles from "./menu.module.css";

export function Menu({ isHome }) {
  const { pathname } = useLocation();
  const { menuState, closeMenu } = useMenu();

  useEffect(() => {
    closeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- closeMenu should only be called when the pathname changes
  }, [pathname]);

  return (
    <div className={`${styles.container}${isHome ? ` ${styles.home}` : ""}`}>
      <div className={`${styles.menu} ${styles[menuState]}`}>
        <nav className={styles.nav}>
          <Link
            to="/"
            className={`${styles.navItem}${
              pathname === "/" ? ` ${styles.current}` : ""
            }`}
          >
            <Text tid="home" />
          </Link>
          <Link
            to="/about"
            className={`${styles.navItem}${
              pathname === "/about" ? ` ${styles.current}` : ""
            }`}
          >
            <Text tid="about" />
          </Link>
          <Link
            to="/events"
            className={`${styles.navItem}${
              pathname === "/events" ? ` ${styles.current}` : ""
            }`}
          >
            <Text tid="events" />
          </Link>
          <Link
            to="/work-with-me"
            className={`${styles.navItem}${
              pathname === "/work-with-me" ? ` ${styles.current}` : ""
            }`}
          >
            <Text tid="work-with-me" />
          </Link>
          <Link
            to="/media/videos"
            className={`${styles.navItem}${
              pathname.startsWith("/media") ? ` ${styles.current}` : ""
            }`}
          >
            <Text tid="media" />
          </Link>
          <Link
            to="/contact"
            className={`${styles.navItem}${
              pathname === "/contact" || pathname === "/thanks"
                ? ` ${styles.current}`
                : ""
            }`}
          >
            <Text tid="contact" />
          </Link>
          <Link
            to="/impressum"
            className={`${styles.navItem}${
              pathname === "/impressum" ? ` ${styles.current}` : ""
            }`}
          >
            Impressum
          </Link>
          <LanguageSelector />
        </nav>
      </div>
    </div>
  );
}
